import React from 'react';
import { styled } from 'linaria/react';
import { css } from 'linaria';
import {
  render,
  NODE_HEADING,
  NODE_IMAGE,
  NODE_QUOTE,
  NODE_PARAGRAPH
} from 'storyblok-rich-text-react-renderer';

import YotpoGallery from '../../../ProductPage/YotpoGallery';
import { theme } from '../../../Theme';
import FeaturedProduct from './FeaturedProduct';
import FeaturedProducts from '../../../StartPage/Content/FeaturedProducts';
import { BaseHeading, Heading5, Quote, BaseText } from '../../../ui/Typography';
import FindifyRecommendationsBlok from './FindifyRecommendations.loadable';
import Image from '../components/Image';

const FlexibleHeroWrapper = styled('section')`
  /* margin-bottom: 2rem; */
  padding: 0 16px;
`;
const FullWidthSlider = css`
  ${theme.below.sm} {
    width: calc(100% + 2rem);
    margin-left: -1rem;
  }
`;

const contentStyles = css`
  ${BaseText};

  ${theme.below.md} {
    margin-bottom: 5rem;
  }

  ${theme.below.sm} {
    font-size: 0.875rem;
    margin-bottom: 1.75rem;

    blockquote > p {
      font-size: unset;
    }
  }

  h2 {
    ${Heading5};
    margin-top: 3.5rem;
    margin-bottom: 0.5rem;
    line-height: 1;

    ${theme.below.sm} {
      margin-top: 2rem;
    }
  }

  h2:first-of-type {
    margin-top: 0;
  }

  section > div > h3,
  section > div > h4 {
    font-size: 1rem;
    text-align: center;
    margin-top: 3.5rem;

    ${theme.below.sm} {
      margin-top: 2rem;
    }
  }

  p + p {
    margin-top: 1.5rem;
  }

  p > a {
    color: ${theme.colors.black};
    text-decoration: underline;
  }

  p,
  .narrow {
    width: 100%;
    max-width: 880px;
    margin-left: auto;
    margin-right: auto;
  }

  ${Quote} {
    text-align: center;
    p.narrow {
      max-width: 650px;
      margin: inherit;
    }
    ${theme.below.sm} {
      &.add-margin {
        margin: 2.25rem auto;
      }
    }
  }

  .video-wrapper {
    width: 100%;
    max-width: 880px;
    height: 0;
    margin: 3.5rem auto;
    position: relative;
    padding-bottom: 56.26%;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .add-margin {
    margin: 2rem auto;
    ${theme.above.sm} {
      margin: 3.5rem auto;
    }
  }

  .featured-image {
    ${theme.below.sm} {
      width: 100vw !important;
      margin-left: -1rem;
    }
  }
`;

const Wysiwyg = props => {
  const { wysiwyg } = props;
  return (
    <FlexibleHeroWrapper className={contentStyles}>
      {render(wysiwyg, {
        nodeResolvers: {
          [NODE_IMAGE]: (children, props) => {
            const dimensions = props.src.split('/')[5].split('x');
            const width = dimensions[0];
            const height = dimensions[1];
            return (
              <Image
                cover={true}
                aspect={`${width}:${height}`}
                width={880}
                className="inline-image narrow add-margin"
                {...props}
              />
            );
          },
          [NODE_HEADING]: (children, props) => (
            <h2 {...props} className="narrow">
              {children}
            </h2>
          ),
          [NODE_QUOTE]: (children, props) => (
            <Quote {...props} className="add-margin">
              {children}
            </Quote>
          ),
          [NODE_PARAGRAPH]: (children, props) => (
            <p {...props} className="narrow">
              {children}
            </p>
          )
        },
        blokResolvers: {
          image: props => {
            const dimensions = props.image.filename.split('/')[5].split('x');
            const width = dimensions[0];
            const height = dimensions[1];
            return (
              <Image
                cover={true}
                className="featured-image add-margin"
                aspect={`${width}:${height}`}
                width={1328}
                src={props.image.filename}
                alt={props.image.alt}
              />
            );
          },
          video: props => {
            const videoUrl = props.embed_url.url;
            const videoId = videoUrl.includes('youtu.be')
              ? videoUrl.split('/')[3]
              : videoUrl.split('/watch?v=')[1];

            return (
              <div className="narrow">
                <div className="video-wrapper add-margin">
                  <iframe
                    width="880"
                    height="495"
                    src={`https://www.youtube.com/embed/${videoId}?rel=0&amp;modestbranding=1&amp;showinfo=0`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            );
          },
          featured_products: props => {
            return (
              <div className={FullWidthSlider}>
                <FeaturedProducts {...props} />
              </div>
            );
          },
          featured_product: props => {
            return <FeaturedProduct {...props} />;
          },
          yotpo: props => {
            return <YotpoGallery galleryId={props.galleryId} />;
          },
          findify_recommendations: props => (
            <FindifyRecommendationsBlok recIdString={props.recIdString} />
          )
        },
        defaultBlokResolver: (name, props) => (
          <p>Missing resolver for "{name}"</p>
        )
      })}
    </FlexibleHeroWrapper>
  );
};

export default Wysiwyg;
